module.exports = __webpack_public_path__ + "static/media/mx.6cd58877.svg";